import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapPastEvent } from "src/utils/mapPastEvents";
import { pastEventsLivePreviewRequestHandler } from "src/utils/pastEventsLivePreviewHandler";
import PastEventWinnersContent from "./PastEventWinnersContent";

/**
 * Payload Live Preview iframe target for a single `past-events` document —
 * renders the same winners detail layout as `PastEventWinners.jsx`, fed by
 * the CMS draft doc instead of the static/API data (same idea as
 * `EntertainmentCardPreview.jsx` / `PromotionCardPreview.jsx`).
 */
const PastEventWinnersPreview = () => {
  const { t, i18n } = useTranslation();
  const { card: event, isLoading } = useHubCardLivePreview(
    "past-events",
    {
      depth: 1,
      mapDoc: mapPastEvent,
      requestHandler: pastEventsLivePreviewRequestHandler,
    },
    i18n.language
  );

  if (isLoading) {
    return (
      <PreviewStatus>
        <Spinner animation="border" variant="light" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </PreviewStatus>
    );
  }

  if (!event) {
    return (
      <PreviewStatus>
        <p>{t("tournament.winners.preview.waitingForDocument")}</p>
      </PreviewStatus>
    );
  }

  return <PastEventWinnersContent event={event} isLivePreview />;
};

const PreviewStatus = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black);
  color: var(--mutedwhite);
  text-align: center;
`;

export default PastEventWinnersPreview;
